import React, { FC, memo } from 'react'

import { Element } from 'react-scroll'

import { useAuth } from '@sportworld/js-sdk/src/context/authContext'

import { icons } from '@/constants/icons'
import { MainMenuNames } from '@/constants/menu'
import { useFindNearestByImgWidth } from '@/hooks/useFindNearestByImgWidth'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'
import useStore from '@/store/useStore'
import { MenuItemType } from '@/types'

import { MenuItemElem } from './styles'

type Props = {
  menuItem: MenuItemType
  onSelected: (menuItem: MenuItemType) => void
  isActive: boolean
  isSidebarFocused: boolean
  isSubMenuItem?: boolean
  isSettingsMenuItem?: boolean
  focusIdPrefix?: string
}

const MenuItemRaw: FC<Props> = ({
  menuItem,
  isSubMenuItem,
  isSettingsMenuItem,
  isSidebarFocused,
  onSelected,
  isActive,
  focusIdPrefix = '',
}) => {
  const { isRegisteredUser } = useAuth()
  const { t } = useCommonTranslation()
  const configMenuItem = useStore(
    (state) =>
      menuItem.appConfigKey && state.common.appConfig[menuItem.appConfigKey],
  )

  const iconSources =
    menuItem.appConfigKey && !isSubMenuItem
      ? configMenuItem?.icon?.sources
      : menuItem?.icon?.sources

  const iconSrc = useFindNearestByImgWidth(iconSources, 80, {
    prioritizeSvg: true,
  })?.url

  const menuItemTitle = menuItem.appConfigKey
    ? configMenuItem?.name
    : menuItem?.shortTitle || menuItem?.title || menuItem?.name

  const isProfileMenuItem = menuItem.name === MainMenuNames.PROFILE

  return (
    <MenuItemElem
      elementType="div"
      onSelected={() => onSelected(menuItem)}
      focusId={focusIdPrefix + menuItem.id}
      $isActiveMenuItem={isActive}
      $isSidebarFocused={isSidebarFocused}
    >
      <Element name={focusIdPrefix + menuItem.id}>
        <img src={iconSrc || menuItem.iconDirectPath} alt="" />
        {isRegisteredUser && isProfileMenuItem && (
          <img
            className={'registered'}
            src={icons.navigation.subscribedIcon}
            alt=""
          />
        )}
        {(isSidebarFocused || isSettingsMenuItem) && menuItemTitle && (
          <>
            <span>{t(menuItemTitle)}</span>
            {menuItem.isFavorite && (
              <img className={'heart'} src={icons.favorites.heart} alt="" />
            )}
          </>
        )}
      </Element>
    </MenuItemElem>
  )
}

export const MenuItem = memo(MenuItemRaw)
